var kosan = kosan || {};

kosan.tileboxes = new function () {

    self = this;

    this.init = function () {
        $('.masonry-grid').masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer'
            
        });

        $('.play-video').on('click', function (e) {
            var videoId = $(this).data("youtubeid");
            setVideoOverlay('<iframe src="https://www.youtube.com/embed/' + videoId +'?rel=0&autoplay=1" width="100%" height="100%" frameborder="0" style="position:absolute;width:100%;height:100%;left:0" allowfullscreen></iframe>');
        });
    }

    function setVideoOverlay(data) {
        $('body').addClass('video-overlay-on');
        $('html').addClass('video-overlay-on');
        var html = '<div class="video-overlay">';
        html += '<div class="video-overlay-content"><div class="video-overlay-close close-video-overlay">&times;</div>' + data + '</div>';
        html += '</div>';

        $('body').prepend(html).hide().fadeIn("fast");
        $('.close-video-overlay').on('click', function (e) {
            closeVideoOverlay();
        });
        $('.video-overlay').on('click', function (e) {
            closeVideoOverlay();
        });

    }

    function closeVideoOverlay() {

        $('.video-overlay').remove();
        $('body').removeClass('video-overlay-on');
        $('html').removeClass('video-overlay-on');

    }

};